import React, { useEffect, useState } from "react";

export default function ContentEditorModal({ content, onClose, onSaved }) {
  const isNew = !content.id;

  const [form, setForm] = useState({
    page: content.page || "home",
    section_type: content.section_type || "text",
    unique_id: content.unique_id || "",
    data: content.data || "{}",
  });

  const save = async () => {
    const url = isNew
      ? "/api/content"
      : `/api/content/${content.id}`;

    const method = isNew ? "POST" : "PUT";

    const res = await fetch(url, {
      method,
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    if (res.ok) {
      onSaved();
      onClose();
    } else {
      alert("Save failed");
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content p-4">
        <h4>{isNew ? "Add Content" : "Edit Content"}</h4>

        <input
          className="form-control mb-2"
          placeholder="Page"
          value={form.page}
          onChange={e => setForm({ ...form, page: e.target.value })}
        />

        <select
          className="form-control mb-2"
          value={form.section_type}
          onChange={e => setForm({ ...form, section_type: e.target.value })}
        >
          <option value="hero">Hero</option>
          <option value="text">Text</option>
          <option value="video">Video</option>
        </select>

        <input
          className="form-control mb-2"
          placeholder="Unique ID"
          value={form.unique_id}
          onChange={e => setForm({ ...form, unique_id: e.target.value })}
        />

        <textarea
          className="form-control mb-3"
          rows={6}
          placeholder="JSON data"
          value={form.data}
          onChange={e => setForm({ ...form, data: e.target.value })}
        />

        <div className="text-end">
          <button className="btn btn-secondary me-2" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={save}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
